import axios from "./axios";

export async function listarUsuariosAcesso(consulta = "") {
  const response = await axios.get("/portal/admin/acessos/usuarios", {
    params: consulta ? { q: consulta } : undefined
  });
  return response.data;
}

export async function buscarUsuarioAcesso(id) {
  const response = await axios.get(`/portal/admin/acessos/usuarios/${id}`);
  return response.data;
}

export async function criarUsuarioAcesso(payload) {
  const response = await axios.post("/portal/admin/acessos/usuarios", payload);
  return response.data;
}

export async function atualizarUsuarioAcesso(id, payload) {
  const response = await axios.put(`/portal/admin/acessos/usuarios/${id}`, payload);
  return response.data;
}

export async function salvarVinculoUsuarioServico(usuarioId, payload) {
  const response = await axios.put(`/portal/admin/acessos/usuarios/${usuarioId}/servicos`, payload);
  return response.data;
}

export async function listarCatalogoServicosAcesso() {
  const response = await axios.get("/portal/admin/acessos/catalogo-servicos");
  return response.data;
}

export async function listarAuditoriaAcessos() {
  const response = await axios.get("/portal/admin/acessos/auditoria");
  return response.data;
}
